// extracted by mini-css-extract-plugin
module.exports = {"backlink":"back-link_backlink__16afA","backlinkContent":"back-link_backlinkContent__onKGz","icon":"back-link_icon__48FZv","text":"back-link_text__FBKNc"};